/**
 * Przewijanie strony: linki z menu przewijają do sekcji bez dopisywania
 * „#kontakt" itp. do adresu, a odświeżenie strony zawsze wraca na górę.
 */

/**
 * @param {string|null} href atrybut href linku
 * @returns {string|null} id sekcji dla linku wewnątrz strony („#..."), inaczej null
 */
export function sectionIdFromHref(href) {
  if (!href || !href.startsWith("#") || href.length < 2) return null;
  return decodeURIComponent(href.slice(1));
}

/**
 * @param {string|undefined} navigationType typ wejścia z Performance API
 * @returns {boolean} czy zacząć od góry strony
 */
export function shouldStartAtTop(navigationType) {
  return navigationType === "reload" || navigationType === "back_forward";
}

export function initScroll() {
  if ("scrollRestoration" in history) history.scrollRestoration = "manual";

  const [entry] = performance.getEntriesByType("navigation");
  if (shouldStartAtTop(entry?.type)) {
    if (location.hash) history.replaceState(null, "", location.pathname + location.search);
    window.scrollTo(0, 0);
  }

  document.addEventListener("click", (event) => {
    const link = event.target.closest("a[href^='#']");
    if (!link) return;
    const id = sectionIdFromHref(link.getAttribute("href"));
    if (!id) return;
    const section = document.getElementById(id);
    if (!section) return;
    event.preventDefault();
    if (id === "top") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      section.scrollIntoView({ behavior: "smooth" });
    }
  });
}
